import React from 'react';
import styled from 'styled-components';

import CollectionBanner from './collection-banner';
import CollectionGrid from './collection-grid';
import CollectionVideo from './collection-video';
import CollectionContentRows from './collection-content-rows';
import CollectionTiles from './collection-tiles';

// for azazie
import VideoPlayer from '../elements/video-player';
import HomeSplitSection from '../page-components/home/home-split-section';
import BottomWave from '../elements/bottom-wave';
import CollectionBlogFeed from './collection-blog-feed';

const CollectionBasicContainer = styled.div`
    .bottom-wave-outer-container {
        position: relative;
        margin-bottom: -70vh;
        top: -60vh;
    }
`;

const CollectionBasic = ({ collection, assets }) => {
    // console.log(assets);

    const acf = (assets && assets.collection_acf) || null;
    const {
        collectionBannerBlurb,
        collectionGridPromo1,
        collectionGridPromo2,
        collectionGridTopText,
        collectionVideoSettings,
        collectionContentRowSettings,
        contentTilesSettings,
        waveCaption,
        collectionLayout,
        collectionSplitSection,
        collectionBottomWaveSettings,
        collectionBlogFeed,
    } = acf || {};

    return (
        <CollectionBasicContainer>
            {acf && (
                <CollectionBanner
                    title={collection.title}
                    caption={collectionBannerBlurb}
                    image={
                        acf.desktopBannerImage.localFile.childImageSharp.fluid
                    }
                />
            )}

            <CollectionGrid
                collectionCaption={collectionGridTopText}
                collection={collection}
                products={collection.products}
                promoOne={collectionGridPromo1}
                promoTwo={collectionGridPromo2}
            />

            {collectionLayout === 'azazie' ? (
                <>
                    {collectionVideoSettings && (
                        <VideoPlayer content={collectionVideoSettings} />
                    )}
                    {collectionSplitSection && (
                        <HomeSplitSection content={collectionSplitSection} />
                    )}
                    {collectionBlogFeed && (
                        <CollectionBlogFeed
                            title={collectionBlogFeed.sectionTitle}
                            handle={collectionBlogFeed.blogCategoryHandle}
                        />
                    )}
                    {collectionBottomWaveSettings && (
                        <div className="bottom-wave-outer-container">
                            <BottomWave
                                content={collectionBottomWaveSettings}
                            />
                        </div>
                    )}
                </>
            ) : (
                <>
                    {collectionVideoSettings && (
                        <CollectionVideo settings={collectionVideoSettings} />
                    )}

                    {collectionContentRowSettings && (
                        <CollectionContentRows
                            collectionContentRowSettings={
                                collectionContentRowSettings
                            }
                        />
                    )}

                    {/* {contentTilesSettings && (
                        <CollectionTiles
                            contentTilesSettings={contentTilesSettings}
                            title={waveTitle}
                            caption={waveCaption}
                            button={waveButton}
                        />
                    )} */}
                </>
            )}
        </CollectionBasicContainer>
    );
};

export default CollectionBasic;
